import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
// Interfaces / Enums
import { CorrelationType } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { FundChartOptionValue, } from 'ChartApp/ts/interfaces/fund-chart.interface';
// Constants
import { FUND_CHART_LINE_WEIGHT_MEDIUM, FUND_CHART_LINE_WEIGHT_THICK, FUND_CHART_LINE_WEIGHT_THIN, LINE_ANNOTATIONS_SECURITY_TYPE_ENABLED_EVENTS_MAP, LINE_ANNOTATION_AREA_CHART, LINE_ANNOTATION_AVG, LINE_ANNOTATION_DIVIDENDS, LINE_ANNOTATION_EARNINGS_RESULTS, LINE_ANNOTATION_FORCE_ORIGINAL, LINE_ANNOTATION_FORCE_ORIGINAL_HELP_MODAL_NAME, LINE_ANNOTATION_FORCE_SINGLE_PANEL, LINE_ANNOTATION_FORCE_SINGLE_PANEL_MODAL_NAME, LINE_ANNOTATION_BOOL_KEYS, LINE_ANNOTATION_LINE_COLOR, LINE_ANNOTATION_LINE_WEIGHT, LINE_ANNOTATION_MAX, LINE_ANNOTATION_MIN, LINE_ANNOTATION_SPINOFFS, LINE_ANNOTATION_SPLITS, LINE_WEIGHT_LABEL_MAP, } from '../fund-chart-correlations/fund-chart-correlations.constants';
// Selectors
import { getLineAnnotationModalStateForSeries, getSeriesLineAnnotations, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/line-annotations/line-annotations.selectors';
// Actions
import { removeFundChartLineAnnotation, setFundChartLineAnnotation, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/line-annotations/line-annotations.actions';
// Components
import { ColorPickerComponent } from 'NewAngular/features/components/inputs/color-picker/color-picker.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/color-picker/color-picker.component";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
const _c0 = ["colorPickerComponent"];
const _c1 = a0 => ({ show: a0 });
const _c2 = a0 => ({ backgroundColor: a0 });
const _c3 = a0 => ({ "custom-control-indicator": a0 });
const _c4 = a0 => ({ disabled: a0 });
function LineAnnotationsModalComponent_label_17_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 27)(1, "input", 28);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_label_17_Template_input_click_1_listener() { const option_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setWeight(option_r3.weight)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span");
    i0.ɵɵelementStart(3, "span", 29);
    i0.ɵɵelement(4, "div");
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", option_r3.weight === ctx_r3.currentLineWeight);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(7, _c3, option_r3.weight === ctx_r3.currentLineWeight));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("thickness ", option_r3.cssClass, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r3.label);
} }
function LineAnnotationsModalComponent_div_33_label_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 31)(1, "input", 32);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_div_33_label_4_Template_input_click_1_listener() { const option_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.setOption(option_r6)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 33);
    i0.ɵɵelementStart(3, "span", 34);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(5, _c4, ctx_r3.eventOptionDisabled(option_r6)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r3.modalState[option_r6.value])("disabled", ctx_r3.eventOptionDisabled(option_r6));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r6.label);
} }
function LineAnnotationsModalComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "label", 6);
    i0.ɵɵtext(2, "View Events");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 23);
    i0.ɵɵtemplate(4, LineAnnotationsModalComponent_div_33_label_4_Template, 5, 7, "label", 30);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r3.ANNOTATIONS_EVENTS_OPTIONS);
} }
function LineAnnotationsModalComponent_label_38_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 31)(1, "input", 35);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_label_38_Template_input_click_1_listener() { const option_r8 = i0.ɵɵrestoreView(_r7).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setOption(option_r8)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 33);
    i0.ɵɵelementStart(3, "span", 34);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r8 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r3.modalState[option_r8.value]);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r8.label);
} }
function LineAnnotationsModalComponent_div_43_span_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_div_43_span_7_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r11); const lineCustomization_r10 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); const helpModal_r12 = i0.ɵɵreference(45); return i0.ɵɵresetView(helpModal_r12.openModal(ctx_r3.LINE_ANNOTATION_MODAL_NAMES[lineCustomization_r10.value])); });
    i0.ɵɵtext(1, "(?)");
    i0.ɵɵelementEnd();
} }
function LineAnnotationsModalComponent_div_43_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 31)(2, "input", 35);
    i0.ɵɵlistener("click", function LineAnnotationsModalComponent_div_43_Template_input_click_2_listener() { const lineCustomization_r10 = i0.ɵɵrestoreView(_r9).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setOption(lineCustomization_r10)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 33);
    i0.ɵɵelementStart(4, "span", 34);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(6, "\u00A0 ");
    i0.ɵɵtemplate(7, LineAnnotationsModalComponent_div_43_span_7_Template, 2, 0, "span", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const lineCustomization_r10 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r3.modalState[lineCustomization_r10.value]);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", lineCustomization_r10.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.LINE_ANNOTATION_MODAL_NAMES[lineCustomization_r10.value]);
} }
export class LineAnnotationsModalComponent {
    constructor(store) {
        this.store = store;
        this.calcId = '';
        this.label = '';
        this.lineColor = '';
        this.securityId = '';
        this.securityType = '';
        this.securitylistName = '';
        this.objectValues = Object.values;
        this.isOpen = false;
        this.showWeightDropDown = false;
        this.currentColor = null;
        this.currentLineWeight = null;
        this.currentLineWeightClass = '';
        this.currentLineWeightLabel = '';
        this.enabledEvents = [];
        this.LINE_ANNOTATION_MODAL_NAMES = {
            [LINE_ANNOTATION_FORCE_ORIGINAL]: LINE_ANNOTATION_FORCE_ORIGINAL_HELP_MODAL_NAME,
            [LINE_ANNOTATION_FORCE_SINGLE_PANEL]: LINE_ANNOTATION_FORCE_SINGLE_PANEL_MODAL_NAME,
        };
        this.ANNOTATIONS_EVENTS_OPTIONS = [
            {
                label: 'Earnings Results (E)',
                value: LINE_ANNOTATION_EARNINGS_RESULTS,
            },
            {
                label: 'Dividends (D)',
                value: LINE_ANNOTATION_DIVIDENDS,
            },
            {
                label: 'Splits (S)',
                value: LINE_ANNOTATION_SPLITS,
            },
            {
                label: 'Spinoffs (S)',
                value: LINE_ANNOTATION_SPINOFFS,
            },
        ];
        this.ANNOTATIONS_LINES_OPTIONS = [
            {
                label: 'Min. Line',
                value: LINE_ANNOTATION_MIN,
            },
            {
                label: 'Max. Line',
                value: LINE_ANNOTATION_MAX,
            },
            {
                label: 'Average Line',
                value: LINE_ANNOTATION_AVG,
            },
        ];
        this.ANNOTATIONS_LINES_CUSTOMIZATIONS = [
            {
                label: 'Force Original Data',
                value: LINE_ANNOTATION_FORCE_ORIGINAL,
            },
            {
                label: 'Force on Single Panel',
                value: LINE_ANNOTATION_FORCE_SINGLE_PANEL,
            },
            {
                label: 'Area Chart',
                value: LINE_ANNOTATION_AREA_CHART,
            },
        ];
        this.LINE_WEIGHT_OPTIONS_MAP = {
            thin: {
                cssClass: 'thickness-thin',
                label: LINE_WEIGHT_LABEL_MAP[FUND_CHART_LINE_WEIGHT_THIN],
                weight: FUND_CHART_LINE_WEIGHT_THIN,
            },
            medium: {
                cssClass: 'thickness-medium',
                label: LINE_WEIGHT_LABEL_MAP[FUND_CHART_LINE_WEIGHT_MEDIUM],
                weight: FUND_CHART_LINE_WEIGHT_MEDIUM,
            },
            thick: {
                cssClass: 'thickness-thick',
                label: LINE_WEIGHT_LABEL_MAP[FUND_CHART_LINE_WEIGHT_THICK],
                weight: FUND_CHART_LINE_WEIGHT_THICK,
            },
        };
        this.useCustomColors = false;
        this.seriesIndex = 0;
        this.modalState = {};
        this.isAlive = true;
        this.mapStateToComponent = (state) => {
            this.rootState = state;
            this.seriesLineAnnotations = getSeriesLineAnnotations(state);
        };
    }
    ngOnInit() {
        this.store
            .select('reducers')
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    eventOptionDisabled(option) {
        return !this.enabledEvents?.includes(option.value);
    }
    openModal(seriesIndex) {
        const seriesLineAnnotation = this.seriesLineAnnotations[seriesIndex];
        this.calcId = seriesLineAnnotation.calcId;
        this.label = seriesLineAnnotation.label;
        this.securityId = seriesLineAnnotation.securityId;
        this.securitylistName = seriesLineAnnotation.securitylistName;
        this.lineColor = seriesLineAnnotation.color;
        this.securityType = seriesLineAnnotation.securityType;
        this.enabledEvents = LINE_ANNOTATIONS_SECURITY_TYPE_ENABLED_EVENTS_MAP[this.securityType];
        this.useCustomColors = this.rootState.fundChart[FundChartOptionValue.SHOW_CUSTOM_COLORS];
        // Initialize modal state from series annotation state
        const securityKey = this.securitylistName ? this.securitylistName : this.securityId;
        this.modalState = { ...getLineAnnotationModalStateForSeries(securityKey, this.calcId)(this.rootState) };
        // For securities with 'force_on_single_panel' as true index can only be 0 since
        // they will be displayed in their own chart.
        this.seriesIndex = this.modalState[LINE_ANNOTATION_FORCE_SINGLE_PANEL] ? 0 : seriesIndex;
        // If we have colors explicitly set in the `lineAnnotations`, we need to set our
        // UI elements appropriately.
        const { line_color, line_weight } = this.modalState;
        this.setColor(line_color);
        this.setWeight(line_weight);
        this.showWeightDropDown = false;
        this.isOpen = true;
    }
    closeModal() {
        this.isOpen = false;
    }
    resetModal() {
        const resetState = LINE_ANNOTATION_BOOL_KEYS.reduce((acc, key) => {
            acc[key] = false;
            return acc;
        }, {});
        if (this.calcId === CorrelationType.CORRELATION) {
            // For Correlation items, the following line annotation options default to true
            resetState[LINE_ANNOTATION_FORCE_ORIGINAL] = true;
            resetState[LINE_ANNOTATION_FORCE_SINGLE_PANEL] = true;
        }
        this.setColor('');
        this.setWeight(null);
        this.modalState = resetState;
        this.lineColor = this.colorPickerComponent.getDefaultColorForIndex(this.seriesIndex);
    }
    setOption(option) {
        this.modalState[option.value] = !this.modalState[option.value];
    }
    submitModal() {
        const cleanedState = {};
        const securityKey = this.securitylistName ? this.securitylistName : this.securityId;
        LINE_ANNOTATION_BOOL_KEYS.forEach((key) => {
            cleanedState[key] = this.modalState[key];
        });
        // Only set the line format-related items if a user has actually set them.
        if (this.currentColor) {
            cleanedState[LINE_ANNOTATION_LINE_COLOR] = this.currentColor;
        }
        if (this.currentLineWeight) {
            cleanedState[LINE_ANNOTATION_LINE_WEIGHT] = this.currentLineWeight;
        }
        if (Object.keys(cleanedState).length === 0) {
            this.store.dispatch(removeFundChartLineAnnotation({ securityId: securityKey, calcId: this.calcId }));
        }
        else {
            this.store.dispatch(setFundChartLineAnnotation({
                securityId: securityKey,
                calcId: this.calcId,
                lineAnnotation: cleanedState,
            }));
        }
        this.closeModal();
    }
    setWeight(lineWeight) {
        this.currentLineWeight = lineWeight;
        let option;
        // If there is no currently-selected weight, we show a "default" value as the
        // pseudo-selected value in the closed dropdown.
        if (lineWeight) {
            option = this.LINE_WEIGHT_OPTIONS_MAP[lineWeight];
        }
        else {
            option = {
                cssClass: 'thickness-unselected',
                label: 'Default',
                weight: FUND_CHART_LINE_WEIGHT_MEDIUM,
            };
        }
        this.currentLineWeightClass = option.cssClass;
        this.currentLineWeightLabel = option.label;
        this.showWeightDropDown = false;
    }
    setColor(color) {
        this.colorPickerComponent.setColor(color, this.seriesIndex);
        this.currentColor = color;
    }
    currentColorHandler(color) {
        this.currentColor = color;
    }
}
LineAnnotationsModalComponent.ɵfac = function LineAnnotationsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LineAnnotationsModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
LineAnnotationsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LineAnnotationsModalComponent, selectors: [["ycn-line-annotations-modal"]], viewQuery: function LineAnnotationsModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.colorPickerComponent = _t.first);
    } }, standalone: false, decls: 47, vars: 22, consts: [["colorPickerComponent", ""], ["helpModal", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "mb-2"], [1, "form-label", "form-label-large"], [1, "row"], [1, "col-4"], [1, "form-inline"], [1, "form-label", "form-label-thin"], [1, "dropdown"], [1, "btn", "btn-block", "btn-secondary", "dropdown-toggle", 3, "click"], [1, "text-default"], [1, "dropdown-menu"], ["class", "dropdown-item custom-control custom-checkbox custom-checkbox-style1", 4, "ngFor", "ngForOf"], [1, "col-auto"], [3, "setColorHandler", "useCustomColors"], [1, "col"], [1, "thickness-wrap"], [1, "divider-horizontal", "mt-2", "mb-1"], [1, "row", "modal-section"], ["class", "col-4", 4, "ngIf"], [1, "custom-controls-stacked"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["cancelButtonText", "Reset", "submitButtonText", "Apply", 3, "cancelHandler", "submitHandler"], [1, "dropdown-item", "custom-control", "custom-checkbox", "custom-checkbox-style1"], [1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-description", "thickness-wrap"], ["class", "custom-control custom-checkbox", 3, "class", 4, "ngFor", "ngForOf"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked", "disabled"], [1, "custom-control-indicator"], [1, "custom-control-description"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], ["class", "help-toggler", 3, "click", 4, "ngIf"], [1, "help-toggler", 3, "click"]], template: function LineAnnotationsModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function LineAnnotationsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function LineAnnotationsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "label", 6);
        i0.ɵɵtext(5, "Line Style");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 7)(7, "div", 8)(8, "div", 9)(9, "div", 10);
        i0.ɵɵtext(10, "Weight");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 11)(12, "a", 12);
        i0.ɵɵlistener("click", function LineAnnotationsModalComponent_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.showWeightDropDown = !ctx.showWeightDropDown); });
        i0.ɵɵelement(13, "span");
        i0.ɵɵelementStart(14, "span", 13);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(16, "span", 14);
        i0.ɵɵtemplate(17, LineAnnotationsModalComponent_label_17_Template, 7, 9, "label", 15);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(18, "div", 16)(19, "div", 9)(20, "div", 10);
        i0.ɵɵtext(21, "Color");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 11)(23, "ycn-color-picker", 17, 0);
        i0.ɵɵlistener("setColorHandler", function LineAnnotationsModalComponent_Template_ycn_color_picker_setColorHandler_23_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.currentColorHandler($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(25, "div", 18)(26, "div", 9)(27, "div", 10);
        i0.ɵɵtext(28, "Example");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 19);
        i0.ɵɵelement(30, "div");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(31, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 21);
        i0.ɵɵtemplate(33, LineAnnotationsModalComponent_div_33_Template, 5, 1, "div", 22);
        i0.ɵɵelementStart(34, "div", 8)(35, "label", 6);
        i0.ɵɵtext(36, "View Min / Max / Avg");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "div", 23);
        i0.ɵɵtemplate(38, LineAnnotationsModalComponent_label_38_Template, 5, 2, "label", 24);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(39, "div", 8)(40, "label", 6);
        i0.ɵɵtext(41, "Line Customizations");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "div", 23);
        i0.ɵɵtemplate(43, LineAnnotationsModalComponent_div_43_Template, 8, 3, "div", 25);
        i0.ɵɵelement(44, "ycn-help-modal", null, 1);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(46, "ycn-simple-modal-footer", 26);
        i0.ɵɵlistener("cancelHandler", function LineAnnotationsModalComponent_Template_ycn_simple_modal_footer_cancelHandler_46_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.resetModal()); })("submitHandler", function LineAnnotationsModalComponent_Template_ycn_simple_modal_footer_submitHandler_46_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submitModal()); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.label);
        i0.ɵɵadvance(12);
        i0.ɵɵclassMapInterpolate1("thickness ", ctx.currentLineWeightClass, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.currentLineWeightLabel);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(18, _c1, ctx.showWeightDropDown));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.objectValues(ctx.LINE_WEIGHT_OPTIONS_MAP));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("useCustomColors", ctx.useCustomColors);
        i0.ɵɵadvance(7);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(20, _c2, ctx.currentColor || ctx.lineColor));
        i0.ɵɵclassMapInterpolate1("thickness ", ctx.currentLineWeightClass, "");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.securityType !== "correlation");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.ANNOTATIONS_LINES_OPTIONS);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.ANNOTATIONS_LINES_CUSTOMIZATIONS);
    } }, dependencies: [i2.ColorPickerComponent, i3.NgForOf, i3.NgIf, i4.HelpModalComponent, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent], encapsulation: 2 });
